<template>
  <v-container grid-list-xl>
    <h2 class="pl-4">
      <span>Autres</span>
      <span class="green--text">Portfolio</span>
    </h2>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="project.dialog"
        lazy
        max-width="800"
        v-for="project in Autres"
        :key="project.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="project.poster"
                aspect-ratio="1.7778"
                contain
                :alt="project.title"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="cardTitle">{{project.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="project.dialog">
          <v-card-title class="cardTitle">
            {{project.title}}
          </v-card-title>
          <v-card-text>
            <h3>Link</h3>
          </v-card-text>
          <v-card-text>
            <a :href="project.link">{{project.link}}</a>
          </v-card-text>
          <v-card-text>
            <h3>Description</h3>
          </v-card-text>
          <v-card-text>
            <p>{{project.description}}</p>
          </v-card-text>
          <v-card-text>
            <h3>Demo</h3>
          </v-card-text>
          <v-card-media v-if="project.demo">
            <div class="iframe-wrapper">
              <iframe :src="project.href" allowfullscreen allowtransparency allow="autoplay" ></iframe>
            </div>
          </v-card-media>
          <v-card-media v-if="!project.demo">
            <v-img contain max-height="500px" :src="project.demo_image"></v-img>
          </v-card-media>
          <v-card-text>
            <!-- <h3 class="headline mb-0">
              <span>Technology</span>
              <span class="right" >Role</span>
            </h3>
             <v-chip color="green" text-color="white">{{project.tech.tech1}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech2}}</v-chip>
            <v-chip class="right" color="green" text-color="white">{{project.role}}</v-chip> -->
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  metainfo: {
    title: 'Autres Portfolio',
    titleTemplate: "%s ← Mathieu's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'description',
        content:
          "Mathieu Baesen's Autres portfolio"
      },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Mathieu' Space" },
      { property: 'og:site_name', content: "Mathieu' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://Mathieu.space' },
      {
        property: 'og:description',
        content: "Mathieu Baesen's Autres portfolio"
      }
    ]
  },
  data () {
    return {
      dialog: false,
      Autres: [
        {
          dialog: false,
          title: 'Mes Compositions pour le Jeu Vidéo',
          poster: 'https://i.imgur.com/3CPxvW2.jpg',/*'https://1000logos.net/wp-content/uploads/2020/08/SoundCloud-Logo.jpg',*/
          demo: false,
          href: 'https://on.soundcloud.com/pK6Fh',
          description: 'Ensemble de mes compositions servant de thèmes ou de musique d\'ambiance aux jeux auxquels j\'ai participé.',
          link: 'https://soundcloud.com/mathieu-baesen-981310929/sets/compositions-perso-jv/s-9DmR5A0XL1n?si=0c1a451d715642458395a1920724b297&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing'
        }
      ]
    }
  }
}
</script>

<style  scoped>
@import "../../../node_modules/vue-plyr/dist/vue-plyr.css";
.cardTitle{
  text-align: center;
  color: green ;
  font-size: x-large;
  justify-content: center;
}
.iframe-wrapper {
  position: relative;
  height: 0;
  padding-top: 56.25%;
  overflow: hidden;
  margin: 3%;
}

.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
